import React from 'react';
import { Button } from './ui/button';
import { Search, Phone } from 'lucide-react';
import { Input } from './ui/input';

const Hero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center bg-white pt-32">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <img 
          src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2000"
          alt="Luxury Real Estate"
          className="w-full h-full object-cover animate-ken-burns"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        {/* Decorative elements with animation */}
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-[#B8944A]/10 rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl animate-pulse-slow animation-delay-400"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          {/* Main Heading with stylish font */}
          <div className="mb-12">
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-black text-white mb-6 leading-tight tracking-tight animate-fade-in-up" style={{ fontFamily: "'Playfair Display', serif", textShadow: '4px 4px 12px rgba(0,0,0,0.8), 0 0 40px rgba(0,0,0,0.5)' }}>
              Bhagat Prop Built
            </h1>
            <div className="flex items-center justify-center gap-4 mb-8 animate-fade-in animation-delay-200">
              <div className="h-1 w-20 bg-[#B8944A] rounded animate-expand-width shadow-lg"></div>
              <div className="w-3 h-3 bg-[#B8944A] rounded-full animate-pulse shadow-lg"></div>
              <div className="h-1 w-20 bg-[#B8944A] rounded animate-expand-width shadow-lg"></div>
            </div>
          </div>

          {/* New Tagline */}
          <p className="text-3xl md:text-4xl text-white mb-4 font-bold tracking-wide animate-fade-in-up animation-delay-400" style={{ textShadow: '3px 3px 10px rgba(0,0,0,0.8), 0 0 30px rgba(0,0,0,0.5)' }}>
            Where Dreams Meet Reality
          </p>
          <p className="text-lg md:text-xl text-white mb-16 max-w-3xl mx-auto leading-relaxed font-semibold animate-fade-in-up animation-delay-600" style={{ textShadow: '2px 2px 8px rgba(0,0,0,0.8), 0 0 20px rgba(0,0,0,0.5)' }}>
            Your Trusted Partner in Premium Real Estate | Authorized Plots | Group Housing | Commercial Spaces
          </p>

          {/* Phone Numbers - Plain design with animation */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 animate-fade-in animation-delay-600">
            <a href="tel:+919999505420" className="flex items-center gap-4 bg-[#B8944A] px-8 py-4 rounded-full hover:bg-[#A07D3A] hover:scale-105 transition-all duration-300 shadow-2xl">
              <Phone className="text-white" size={24} />
              <span className="text-white text-xl font-bold">9999505420</span>
            </a>
            <span className="text-white/80 text-2xl hidden sm:block font-bold">|</span>
            <a href="tel:+917838486828" className="flex items-center gap-4 bg-[#B8944A] px-8 py-4 rounded-full hover:bg-[#A07D3A] hover:scale-105 transition-all duration-300 shadow-2xl">
              <Phone className="text-white" size={24} />
              <span className="text-white text-xl font-bold">7838486828</span>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom wave decoration */}
      <div className="absolute bottom-0 left-0 right-0 z-10">
        <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 48L60 42.7C120 37 240 27 360 26.7C480 27 600 37 720 42.7C840 48 960 48 1080 42.7C1200 37 1320 27 1380 21.3L1440 16V80H1380C1320 80 1200 80 1080 80C960 80 840 80 720 80C600 80 480 80 360 80C240 80 120 80 60 80H0V48Z" fill="white"/>
        </svg>
      </div>
    </section>
  );
};

export default Hero;